import {
  AuthAddressAlreadyInUseError,
  AuthEmailValidationError,
  AuthExpiredVerificationCodeError,
  AuthInvalidCredentialsError,
  AuthInvalidVerificationCodeError,
  AuthNotFoundError,
  AuthUserNotEnabledError,
} from "@/domain/errors/auth";
import { isAxiosError } from "axios";

const registerHandler = (error: unknown) => {
  if (!isAxiosError(error)) return;
  if (
    error?.response?.status === 400 &&
    error?.response?.data?.error ===
      "email address already in use by another user"
  ) {
    return new AuthAddressAlreadyInUseError();
  }
};

const loginHandler = (error: unknown) => {
  if (!isAxiosError(error)) return;
  if (error?.response?.status === 401) {
    const errorData = error?.response?.data?.error;
    if (["user not enabled", "email verification not performed"].includes(errorData))
      return new AuthUserNotEnabledError();
    if (errorData === "invalid credentials")
      return new AuthInvalidCredentialsError();
  }
};

const verifyEmailHandler = (error: unknown) => {
  if (!isAxiosError(error)) return;
  if (error?.response?.status === 403) {
    const errorData = error?.response?.data?.error;
    if (errorData === "invalid verification token")
      return new AuthInvalidVerificationCodeError();
    if (errorData === "verification token expired")
      return new AuthExpiredVerificationCodeError();
  }
};

const resetVerifyEmailHandler = (error: unknown) => {
  if (!isAxiosError(error)) return;
  if (error.response?.status === 400) {
    const errorData = error.response?.data?.error as string;
    if (errorData.includes("Field validation for 'Email' failed"))
      return new AuthEmailValidationError();
    if (errorData === "user not found")
      return new AuthNotFoundError();
  }
}

export const AuthRepositoryErrorHandler = {
  Register: registerHandler,
  Login: loginHandler,
  VerifyEmail: verifyEmailHandler,
  ResetVerifyEmail: resetVerifyEmailHandler,
};
